import { Search } from "../components/ui/search";
export default Search;